export default "__VITE_ASSET__Bb_HshAZ__"